<template>
  <el-container class="permission-doc" direction="vertical">
    <el-row style="width: 100%; height: 49px;">
      <el-menu class="horizontal-menu" :default-active="activeIndex" mode="horizontal" @select="handleSelect"
               unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(1, 1, 1, 1)">
        <el-menu-item class="horizontal-menu-item" :index="1">操作员管理</el-menu-item>
        <el-menu-item class="horizontal-menu-item" :index="2">权限组管理</el-menu-item>
      </el-menu>
      <el-row style="height: 1px;width: 100%;background-color: #FFF" />
    </el-row>
    <common-panel style="height: calc(100% - 49px);" :panel-data="selPanel" :key="activeIndex"/>
  </el-container>
</template>

<script>
import {Message} from 'element-ui';
import CommonPanel from "../../common/panel/CommonPanel";
export default {
  name: "PermissionManage",
  components: {CommonPanel},
  created() {
    this.selPanel = this.operatorPanel;
  },
  data() {
    return{
      activeIndex: 1,
      selPanel: null,
      // 操作员
      operatorPanel: {
        hasTree: false,
        hasTreeToolbar: false,
        queryMethod: this.$api.systemManage.getSysUser,
        filterForm: [
          {label: '名称：', prop: 'userName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '新增', icon: 'zy-icon-plus', type: 'add', handleIndex: -1},
          {label: '修改', icon: 'zy-icon-edit', type: 'edit', handleIndex: -2, text: true},
          {label: '重置密码', icon: 'zy-icon-setting-gear', type: 'resetPsw', handleIndex: -2, text: true},
          {label: '删除', icon: 'zy-icon-delete', type: 'del', handleIndex: 2}
        ],
        methods: {
          add: this.$api.systemManage.addSysUser,
          edit: this.$api.systemManage.updateSysUser,
          del: this.$api.systemManage.deleteSysUser,
          del_prop: 'id',
          resetPsw: this.$api.systemManage.resetPsw
        },
        tableCheck: true,
        tableTitle: '操作员列表',
        tableProps: [
          {prop: "userName", label: "名称"},
          {prop: "userAccount", label: "账号"},
          {prop: "roleName", label: "权限组"},
          {prop: "remark", label: "备注"}
        ],
        drawerTitle: '操作员信息',
        dialogs: {
          add_edit: {
            title: '操作员信息',
            width: '700px',
            editFlag: false,
            items: [
              {type: 'input', prop: 'userName', label: '名称：', placeholder: '请输入名称', style: 'width: 315px;'},
              {type: 'input', prop: 'userAccount', label: '账号：', placeholder: '请输入描述', style: 'width: 315px;', editable: true},
              {type: 'select', prop: 'roleId', label: '操作员角色：', style: 'width: 315px;',
                method: this.$api.systemManage.getRoleList,
                props: {value: 'id', label: 'roleName'},
                options: []
              },
              {type: 'input', prop: 'password', label: '密码：', style: 'width: 315px;', editable: true},
              {type: 'multi_select', prop: 'siteId', label: '站点名称：', style: 'width: 315px;',
                method: this.$api.systemManage.getSiteList,
                props: {value: 'id', label: 'buildName'},
                options: []
              },
              {type: 'input', prop: 'remark', label: '备注：', style: 'width: 315px;'},
              {type: 'input', prop: 'systemName', label: '平台名称：', style: 'width: 315px;'},
              {type: 'logo', prop: 'file', label: 'LOGO：', style: 'width: 315px;'}
            ],
            rules: {
              userName: [
                {required: true, message: '请输入名称', trigger: 'blur'}
              ],
              userAccount: [
                {required: true, message: '请输入名称', trigger: 'blur'}
              ],
              roleId: [
                {required: true, message: '请选择角色', trigger: 'blur'}
              ],
              password: [
                {required: true, message: '请输入密码', trigger: 'blur'}
              ],
              siteId: [
                {required: true, message: '请选择站点', trigger: 'blur'}
              ]
            },
            ruleValidator: [
              {name: 'userAccount', type: 'account', validator: null, method: this.$api.systemManage.checkUserAccount}
            ],
            confirmMethod: null
          }
        }
      },
      // 权限组
      permissionGroupPanel: {
        hasTree: false,
        hasTreeToolbar: false,
        queryMethod: this.$api.systemManage.getSysRole,
        filterForm: [
          {label: '名称：', prop: 'roleName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '新增', icon: 'zy-icon-plus', type: 'add', handleIndex: -1},
          {label: '修改', icon: 'zy-icon-edit', type: 'edit', handleIndex: -2, text: true},
          {label: '删除', icon: 'zy-icon-delete', type: 'del', handleIndex: 1}
        ],
        methods: {
          add: this.$api.systemManage.addSysRole,
          edit: this.$api.systemManage.updateSysRole,
          del: this.$api.systemManage.deleteSysRole,
          del_prop: 'id'
        },
        tableCheck: true,
        tableTitle: '权限组列表',
        tableProps: [
          {prop: "roleName", label: "名称"},
          {prop: "remark", label: "描述"}
        ],
        drawerTitle: '权限组信息',
        dialogs: {
          add_edit: {
            title: '权限组信息',
            width: '700px',
            type: 'dialog_tree_table',
            menus: '1',
            items: [
              {type: 'input', prop: 'roleName', label: '名称：', placeholder: '请输入名称', style: 'width: 250px;'},
              {type: 'input', prop: 'remark', label: '描述：', placeholder: '请输入描述', style: 'width: 250px;'}
            ],
            tree: {
              props: {
                label: 'name',
                children: 'childNode'
              },
              getTreeMethod: this.$api.systemManage.getPermTree,
              showCheck: true,
              menuMethod: this.$api.systemManage.getRoleMenu
            },
            rules: {
              roleName: [
                {required: true, message: '请输入名称', trigger: 'blur'}
              ]
            },
            ruleValidator: [
              {name: 'roleName', type: 'name', validator: null, method: this.$api.systemManage.checkRoleName}
            ],
            confirmMethod: null
          }
        }
      }
    }
  },
  methods: {
    handleSelect(val) {
      this.activeIndex = val;
      switch (val) {
        case 1:
          this.selPanel = this.operatorPanel;
          break;
        case 2:
          this.selPanel = this.permissionGroupPanel;
          break;
        default:
          Message.warning('未知档案类型');
      }
    }
  }
}
</script>

<style scoped>
  .permission-doc{
    width: 100%;
    height: 100%;
  }
  .horizontal-menu{
    border: 0;
    overflow-y: auto;
    height: 48px !important;
    line-height: 48px !important;
  }
  .horizontal-menu-item{
    border: 0;
    height: 48px !important;
    line-height: 48px !important;
    text-align: center;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .horizontal-menu-item:hover{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }
  .horizontal-menu-item.is-active{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.8) !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SystemSetting/PermissionManage.vue